(function () {
  'use strict';

  window.__c27Support = window.__c27Support || {};

  var FADE_BG = '#f5f5f5';
  var FADE_IN_MS = 160;
  var FADE_OUT_MS = 120;
  var MIN_VISIBLE_MS = 240;
  var MAX_WAIT_MS = 4500;
  var Z_INDEX = 9999;
  var FRAME_DELAY_MS = 16;
  var READY_FRAMES = 2;

  var activeTransition = null;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function waitForFrames(frameCount) {
    return new Promise(function (resolve) {
      var remaining = frameCount;

      function step() {
        remaining -= 1;
        if (remaining <= 0) {
          resolve();
          return;
        }
        window.requestAnimationFrame(step);
      }

      window.requestAnimationFrame(step);
    });
  }

  function waitForMs(durationMs) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, Math.max(durationMs, 0));
    });
  }

  function clearActiveTransition() {
    if (!activeTransition) return;
    window.clearTimeout(activeTransition.fallbackTimer);
    activeTransition.overlay.remove();
    activeTransition = null;
  }

  function finishActiveTransition() {
    var transition = activeTransition;
    if (!transition || transition.isFinishing) return;

    transition.isFinishing = true;
    window.clearTimeout(transition.fallbackTimer);

    var visibleMs = Date.now() - transition.shownAt;
    var remainingVisibleMs = MIN_VISIBLE_MS - visibleMs;

    Promise.all([waitForFrames(READY_FRAMES), waitForMs(remainingVisibleMs)]).then(function () {
      transition.overlay.style.transition = 'opacity ' + FADE_OUT_MS + 'ms ease-out';
      transition.overlay.style.opacity = '0';

      window.setTimeout(function () {
        if (activeTransition === transition) {
          transition.overlay.remove();
          activeTransition = null;
        }
      }, FADE_OUT_MS);
    });
  }

  function playRouteFade() {
    clearActiveTransition();

    var overlay = document.createElement('div');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.dataset.c27SupportRouteFade = 'true';
    overlay.style.position = 'fixed';
    overlay.style.inset = '0';
    overlay.style.zIndex = String(Z_INDEX);
    overlay.style.background = FADE_BG;
    overlay.style.opacity = '0';
    overlay.style.pointerEvents = 'none';
    overlay.style.transition = 'opacity ' + FADE_IN_MS + 'ms ease-out';
    document.body.appendChild(overlay);

    var ready = new Promise(function (resolve) {
      window.setTimeout(function () {
        overlay.style.opacity = '1';
      }, FRAME_DELAY_MS);
      window.setTimeout(resolve, FADE_IN_MS + FRAME_DELAY_MS);
    });

    activeTransition = {
      overlay: overlay,
      shownAt: Date.now() + FRAME_DELAY_MS,
      fallbackTimer: window.setTimeout(function () {
        finishActiveTransition();
      }, MAX_WAIT_MS),
      isFinishing: false,
    };

    return ready;
  }

  function shouldHandleLink(event, link) {
    if (
      !link ||
      !link.href ||
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.altKey ||
      event.ctrlKey ||
      event.shiftKey
    ) {
      return false;
    }

    if (link.target && link.target !== '_self') return false;
    if (link.origin !== window.location.origin) return false;
    return true;
  }

  function bindRouteFadeLinks(root) {
    var scope = root || document;
    var links = scope.querySelectorAll('[data-c27-support-route-fade]');

    links.forEach(function (link) {
      if (link.dataset.c27SupportRouteFadeBound === 'true') return;
      link.dataset.c27SupportRouteFadeBound = 'true';

      link.addEventListener('click', function (event) {
        if (!shouldHandleLink(event, link)) return;

        event.preventDefault();

        if (prefersReducedMotion()) {
          window.location.assign(link.href);
          return;
        }

        playRouteFade().then(function () {
          window.location.assign(link.href);
        });
      });
    });
  }

  window.__c27Support.routeFade = {
    play: playRouteFade,
    finish: finishActiveTransition,
    bind: bindRouteFadeLinks,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindRouteFadeLinks(document);
    });
  } else {
    bindRouteFadeLinks(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bindRouteFadeLinks(event.target);
  });
})();
